/**
 * `W5-T15` §4.1 — where a booking is shown.
 *
 * `from` marks a page reached from a confirm, which is what makes the page watch the booking (§3.2):
 * `checkout` when Stripe.js resolved in the tab, `stripe` when Stripe redirected back. Nothing else
 * ever rides in this URL — Stripe's own parameters are removed on arrival (AC 21).
 */
export type BookingReturn = 'checkout' | 'stripe';

export function bookingPath(locale: string, bookingId: string, from?: BookingReturn): string {
  const path = `/${locale}/bookings/${bookingId}`;
  return from === undefined ? path : `${path}?return=${from}`;
}
